<template>
    <video class="absolute inset-0 w-full h-full object-cover" :class="classes" autoplay muted loop :poster="poster">
        <source :src="readyMp4" type="video/mp4" />
        <source v-if="webm" :src="readyWebm" type="video/webm" />
    </video>
</template>

<script>
export default {
    props: {
        mp4: null,
        webm: null,
        poster: null,
        classes: null
    },

    data() {
        return {
            readyMp4: null,
            readyWebm: null
        };
    },

    mounted() {
        if (window.innerWidth > 1024) {
            this.readyMp4 = this.mp4;
            this.readyWebm = this.webm;
        }
    }
};
</script>
